import Context from "./components/Context";
export * from "./icons";
export { getTwoToneColor, setTwoToneColor } from "./components/twoTonePrimaryColor";
export { default as createFromIconfontCN } from "./components/IconFont";
export { default } from "./components/Icon";
export const IconProvider = Context.Provider;